import React from 'react';
import { Location } from 'history';
import LoggedInHomepage from './homepage/logged_in';
import LoggedOutHomepage from './homepage/logged_out';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { MParticlePageName, trackPageView } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';
import { trackCriteoHomepageView } from '@reverbdotcom/commons/src/criteo';

interface IProps extends IUserContext {
  location?: Location;
}

export class Reverb extends React.Component<IProps, any> {
  componentDidMount() {
    this.logView();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.location && this.props.location) {
      this.logView();
    }
  }

  logView() {
    trackPageView({
      pageName: MParticlePageName.Homepage,
      experiments: formatExperimentsForEventAttributes(this.props.user, [
        experiments.DUMMY,
        experiments.MV_DUMMY,
        experiments.HOMEPAGE_SELL_VISIBILITY_V3,
        experiments.DEALS_AND_STEALS_ROWS_V2,
      ]),
    });

    trackCriteoHomepageView(this.props.user);
  }

  render() {
    if (this.props.user.loggedOut) {
      return <LoggedOutHomepage />;
    }

    return <LoggedInHomepage />;
  }
}

export default withUserContext(Reverb);
